import React from 'react';
import {useTranslation} from 'react-i18next';
import {useParams} from 'react-router-dom';

import {
  Modal,
  ModalActions,
  ModalCancelButton,
  ModalHeader,
  ModalSubmitButton,
  showModal,
} from '@edna/components';

import {ModalCenterImage, Text} from 'src/components/primitives';
import {CarefulImage} from 'src/images';

import {useDeletePayKeeperInfoMutation} from '../api';

const PayKeeperDeleteCardModal = React.memo<{closeModal: TEmptyFunction; userId?: number}>(
  ({closeModal, userId}) => {
    const {t} = useTranslation();
    const {id: tenantId} = useParams<'id'>();

    const [deletePayKeeperInfo] = useDeletePayKeeperInfoMutation();

    const handleDelete = React.useCallback(() => {
      deletePayKeeperInfo(tenantId && userId ? {tenantId, userId} : undefined);
      closeModal();
    }, [closeModal, tenantId, userId]);

    return (
      <Modal width="430px">
        <ModalHeader>{t('BalanceReplenishment:payKeeperDeleteCardModal.title')}</ModalHeader>
        <Text secondary>{t('BalanceReplenishment:payKeeperDeleteCardModal.subtitle')}</Text>
        <ModalCenterImage as={CarefulImage} />
        <ModalActions>
          <ModalCancelButton onClick={closeModal}>{t('Common:button.cancel2')}</ModalCancelButton>
          <ModalSubmitButton onClick={handleDelete}>
            {t('BalanceReplenishment:payKeeperDeleteCardModal.submit')}
          </ModalSubmitButton>
        </ModalActions>
      </Modal>
    );
  },
);

export const showPayKeeperDeleteCardModal = (userId?: number) =>
  showModal((closeModal) => <PayKeeperDeleteCardModal closeModal={closeModal} userId={userId} />);
